module.exports = __webpack_public_path__ + "static/img/5_03.6f400097.png";